<template>
  <SettingsStyled @click="activateSettingsOverlay" :class="{ active: isActive }">
    <SettingsIcon />
  </SettingsStyled>
</template>

<script>
import { styled } from '@egoist/vue-emotion'
import chroma from 'chroma-js'
import { flexCenter, buttonReset } from '@styles/mixins'

import { SettingsIcon } from 'vue-feather-icons'

const SettingsStyled = styled('button')`
  ${buttonReset}
  ${flexCenter}
  padding: 0;
  margin: 0;
  grid-area: settings;
  background: ${props => props.theme.colors.solidBG};
  &:hover,
  &.active {
    background: ${props => chroma(props.theme.colors.solidBG).darken(0.2).css()};
  }
`

export default {
  props: {
    isActive: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    SettingsStyled,
    SettingsIcon,
  },
  methods: {
    activateSettingsOverlay() {
      this.$emit('activateOverlay', 'SettingsOverlay')
    },
  },
}
</script>
